export default {
  /*login: 'http://localhost:9090/api/login',
  check: 'http://localhost:9090/api/check_token',
  estimate: 'http://localhost:9090/api/estimate'*/
  login: '/api/login',
  check: '/api/check_token',
  estimate: '/api/estimate'
  /*login: 'http://vps663592.ovh.net/api/login',
  check: 'http://vps663592.ovh.net/api/check_token',
  estimate: 'http://vps663592.ovh.net/api/estimate'*/
}